export default __webpack_public_path__ + "static/media/vuesax-linear-message-text.904cecf3.svg";